import { handleActions } from 'redux-actions';
import { NOT_REQUESTED, REQUESTED, FAILED, SUCCEEDED } from 'forms-utils-lib/RequestState';
import { FAIL_GETTING_SUBSCRIPTIONS_STATUS, RECEIVE_SUBSCRIPTIONS_STATUS, REQUEST_SUBSCRIPTIONS_STATUS } from 'ui-forms-editor-automation-lib/actions/fetchSubscriptionsStatus';
import { FAIL_GETTING_SUBSCRIPTIONS_DETAILS, RECEIVE_SUBSCRIPTIONS_DETAILS, REQUEST_SUBSCRIPTIONS_DETAILS } from 'ui-forms-editor-automation-lib/actions/fetchSubscriptionsDetails';
import { CHANGE_SUBSCRIPTION_STATUS } from 'ui-forms-editor-automation-lib/actions/updateEspCheckbox';
import { FAIL_UPDATE_SUBSCRIPTIONS, REQUEST_UPDATE_SUBSCRIPTIONS, SUCCESS_UPDATE_SUBSCRIPTIONS } from 'ui-forms-editor-automation-lib/actions/updateSubscriptionsBulk';
export const INITIAL_STATE = {
  subscriptionsStatus: {},
  subscriptionsDetails: [],
  requestStateStatus: NOT_REQUESTED,
  requestStateDetails: NOT_REQUESTED,
  requestStateSaving: NOT_REQUESTED
};
export default handleActions({
  [REQUEST_SUBSCRIPTIONS_STATUS]: state => Object.assign({}, state, {
    subscriptionsStatus: Object.assign({}, state.subscriptionsStatus, {
      count: undefined
    }),
    requestStateStatus: REQUESTED
  }),
  [RECEIVE_SUBSCRIPTIONS_STATUS]: (state, {
    payload
  }) => Object.assign({}, state, {
    subscriptionsStatus: payload,
    requestStateStatus: SUCCEEDED
  }),
  [FAIL_GETTING_SUBSCRIPTIONS_STATUS]: state => Object.assign({}, state, {
    requestStateStatus: FAILED
  }),
  [REQUEST_SUBSCRIPTIONS_DETAILS]: state => Object.assign({}, state, {
    requestStateDetails: REQUESTED
  }),
  [RECEIVE_SUBSCRIPTIONS_DETAILS]: (state, {
    payload
  }) => Object.assign({}, state, {
    subscriptionsDetails: payload,
    requestStateDetails: SUCCEEDED
  }),
  [FAIL_GETTING_SUBSCRIPTIONS_DETAILS]: state => Object.assign({}, state, {
    requestStateDetails: FAILED
  }),
  [CHANGE_SUBSCRIPTION_STATUS]: (state, {
    payload
  }) => Object.assign({}, state, {
    subscriptionsDetails: payload
  }),
  [REQUEST_UPDATE_SUBSCRIPTIONS]: state => Object.assign({}, state, {
    requestStateSaving: REQUESTED
  }),
  [SUCCESS_UPDATE_SUBSCRIPTIONS]: state => Object.assign({}, state, {
    requestStateSaving: SUCCEEDED
  }),
  [FAIL_UPDATE_SUBSCRIPTIONS]: state => Object.assign({}, state, {
    requestStateSaving: FAILED
  })
}, INITIAL_STATE);